import styled from 'styled-components';

const SpecialLabelText = styled.div`
  color: var(--grey700);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  height: 16px;
`;
export default SpecialLabelText;
